<!--<div class="card card-box mb-5">-->
<!--  <div class="card-header py-3">-->
<!--    <div class="card-header&#45;&#45;title font-size-lg">-->
<!--      <b><i class="fas fa-cog"></i> Ticketing </b>-->
<!--    </div>-->
<!--    <div class="card-header&#45;&#45;actions">-->
<!--      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">-->
<!--                      <span class="btn-wrapper&#45;&#45;icon">-->
<!--                          <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
<!--                      </span>-->
<!--        <span class="btn-wrapper&#45;&#45;label">-->
<!--                          Add ticket-->
<!--                      </span>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-between px-4 py-3">-->
<!--    <div class="search-wrapper">-->
<!--          <span class="icon-wrapper text-black">-->
<!--            <fa-icon [icon]="['fas', 'search']"></fa-icon>-->
<!--          </span>-->
<!--      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="divider"></div>-->
<!--  <div class="table-responsive">-->
<!--    <table class="table table-hover text-nowrap mb-0">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        &lt;!&ndash;        <th class="bg-white text-center">ID</th>&ndash;&gt;-->
<!--        <th class="bg-white text-center">Title</th>-->
<!--        <th class="bg-white text-center">DESTINATION</th>-->
<!--        <th class="bg-white text-center">ORIGIN</th>-->
<!--        <th class="bg-white text-center">PRICE</th>-->

<!--        <th class="bg-white text-center">Actions</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr *ngFor="let pac of ticket">-->
<!--        &lt;!&ndash;        <td class="font-weight-bold text-center">&ndash;&gt;-->
<!--        &lt;!&ndash;         {{pac.id}}&ndash;&gt;-->
<!--        &lt;!&ndash;        </td>&ndash;&gt;-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.title}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.destination.city}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.origin.city}}-->
<!--        </td>-->
<!--        <td class="text-center">-->
<!--          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">-->
<!--            {{pac.price}}-->
<!--          </span>-->
<!--        </td>-->

<!--        <td class="text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--            &lt;!&ndash;            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>&ndash;&gt;-->
<!--            <button type="button" class="btn btn-warning" (click)="update(pac)">-->
<!--              <i class="fas fa-edit"></i>-->
<!--            </button>-->
<!--            <button type="button" class="btn btn-danger" (click)="openModal(errorModal,pac.id)"><i-->
<!--              class="fas fa-times-circle"></i></button>-->

<!--          </div>-->
<!--        </td>-->
<!--      </tr>-->

<!--      </tbody>-->
<!--    </table>-->


<!--  </div>-->
<!--  <div class="card-footer py-3 d-flex justify-content-between">-->

<!--  </div>-->
<!--</div>-->

<!--<ng-template #successModal>-->
<!--  <div class="text-center p-5">-->
<!--    <div class="avatar-icon-wrapper rounded-circle m-0">-->
<!--      <div-->
<!--        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-success text-success m-0 d-130">-->
<!--        <fa-icon [icon]="['far', 'lightbulb']" class="d-flex align-self-center display-3"></fa-icon>-->
<!--      </div>-->
<!--    </div>-->
<!--    <h4 class="font-weight-bold mt-4">Do you want to CONFIREM this?</h4>-->
<!--    <p class="mb-0 font-size-lg text-muted">You can later review your options.</p>-->
<!--    <div class="pt-4">-->
<!--      <button (click)="declineConfirem()" class="btn btn-pill btn-neutral-dark mx-1" type="button">-->
<!--                <span class="btn-wrapper&#45;&#45;label">-->
<!--                    Cancel-->
<!--                </span>-->
<!--      </button>-->
<!--      <button (click)="confirmConfirem()" class="btn btn-pill btn-success mx-1" type="button">-->
<!--                <span class="btn-wrapper&#45;&#45;label">-->
<!--                    Confirem-->
<!--                </span>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->




<notifier-container></notifier-container>

<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-10">
        <h4><b>Air tickets</b></h4>
        <p class="text-muted">Please fill out the search criteria to search</p>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-success" (click)="createModal()"> Create new</button>
      </div>
    </div>

    <hr class="mb-3">
    <form [formGroup]="ticketForm">
    <div class="row mb-3">
      <div class="col-4">
        <label for="title1">Title</label>
        <input id="title1" type="text" class="form-control" style="height: calc(1.5em + 1.06rem + -4px);">
      </div>
      <div class="col-3">
        <label for="origin1">Origin</label>
        <ng-select id="origin1" formControlName="origin" [multiple]="false">
          <ng-option *ngFor="let car of items" [value]="car.id">{{car.country}}</ng-option>
        </ng-select>
      </div>
      <div class="col-3">
        <label for="destination1">destination</label>
        <ng-select formControlName="destination" id="destination1" [multiple]="false">
          <ng-option *ngFor="let car of items" [value]="car.id">{{car.country}}</ng-option>
        </ng-select>
      </div>

      <div class="col-1">
        <button (click)="ticketSearch(currentPage)" class="btn btn-info" style="padding-top: 6px;height: calc(1.5em + 1.06rem + -4px);  margin-top: 29px;">Search</button>
      </div>
    </div>
    </form>
    <h4><b>Search Result</b></h4>
    <p class="text-muted">find out all the search result based on above criteria</p>
    <hr>

    <div class="row">
      <div class="col-12" *ngFor="let pac of ticket">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <img class="img" src="assets/images/4775543.svg" alt="">
              </div>
              <div class="col-7">
                <h5 class="mt-3"><b>{{pac.title}}</b></h5>
                <p>{{pac.destination.code}} - {{pac.origin.code}}</p>
                <p>LKR {{pac.price}}</p>
              </div>
              <div class="col-2">
                <div class="mb-2">
                  <button class="btn btn-warning btn-sm" style="width: 100px" (click)="update(pac)">Update</button>
                </div>
                <div>
                  <button (click)="openModal(errorModal,pac.id)" class="btn btn-danger btn-sm" style="width: 100px;">Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer py-3 d-flex justify-content-between">
      <pagination [totalItems]="totalRec" [(ngModel)]="currentPage" (pageChanged)="ticketGetAll($event.page)" class="pagination-icons pagination-warning"></pagination>
    </div>
  </div>
</div>

<ng-template #errorModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div
        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Are you sure you want to DELETE this entry?</h4>
    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>
    <div class="pt-4">
      <button (click)="declineCancel()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
                <span class="btn-wrapper--label">
                    Cancel
                </span>
      </button>
      <button (click)="confirmCancel()" class="btn btn-pill btn-danger mx-1" type="button">
                <span class="btn-wrapper--label">
                    Delete
                </span>
      </button>
    </div>
  </div>
</ng-template>


<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Add Ticket</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="ticketForm">
          <div class="row">
            <div class="mb-2 col-6">
              <label for="title">Title</label>
              <input type="text" class="form-control" formControlName="title" id="title">
            </div>
            <div class="mb-2 col-6">
              <label for="price">price</label>
              <input type="text" class="form-control" formControlName="price" id="price">
            </div>
            <div class="mb-2 col-6">
              <label for="destination">destination</label>
              <ng-select formControlName="destination"  id="destination"  [multiple]="false">
                <ng-option *ngFor="let car of items" [value]="car.id">{{car.country}}</ng-option>

              </ng-select>
            </div>
            <div class="mb-2 col-6">
              <label for="origin">Origin</label>
              <ng-select id="origin"   formControlName="origin" [multiple]="false">
                <ng-option *ngFor="let car of items" [value]="car.id">{{car.country}}</ng-option>
              </ng-select>
            </div>

            <div class="mb-2 col-12">
              <ngx-dropzone (change)="onSelect($event)">
                <ngx-dropzone-label>Drop!</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                  <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <button *ngIf="isup !='up'" type="button" class="btn btn-success ml-auto" (click)="createTicket()">Save changes</button>
        <button *ngIf="isup =='up'" type="button" class="btn btn-warning ml-auto" (click)="updateTicket()">Update</button>
      </div>
    </div>
  </div>
</div>
